import { useState, useEffect } from 'react';
/* eslint-disable */

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { alpha } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useDataContext } from '../../../context/index';
import { useNavigate } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';

import { account } from 'src/_mock/account';
import { useCookies } from 'react-cookie';
import { jwtDecode } from 'jwt-decode';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'หน้าหลัก',
    icon: 'eva:home-fill',
  },
  {
    label: 'โปรไฟล์',
    icon: 'eva:person-fill',
  },
  {
    label: 'นามบัตร',
    icon: 'eva:person-fill',
  },
  {
    label: 'บัตรพนักงาน',
    icon: 'eva:settings-2-fill',
  },
  {
    label: 'ตั้งค่าคุกกี้และ PDPA',
    icon: 'eva:shield-fill',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const { data, setData } = useDataContext();

  const [open, setOpen] = useState(null);
  const [cookies, setCookie, removeCookies] = useCookies(['session']);

  const [name, setName] = useState(null);
  console.log("🚀 ~ AccountPopover ~ name:", name)
  const [decodeData, setDecodeData] = useState(null);
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  useEffect(() => {
    // ตรวจสอบและถอดรหัส token
    let decodedToken = null;
    try {
      if (cookies?.session && typeof cookies.session === 'string') {
        decodedToken = jwtDecode(cookies.session);
      } else {
        console.warn('Invalid or missing session cookie');
      }
    } catch (error) {
      console.error('Error decoding token:', error.message);
    }

    // หา employeeId ตาม userId
    if (decodedToken) {
      const foundEmployee = data?.getAllEmployees?.find(
        (employee) =>
             (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
        (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||(employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||(employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase())
      );
      
      setName(foundEmployee);
      setDecodeData(decodedToken);
    }
  }, [cookies, data]);
  const decodedToken = jwtDecode(cookies?.session);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  const handleLogout = () => {
    if (decodedToken.candidateId) {
      window.location.href = '/loginCandidate';
    }
    if (accounts[0]?.idToken) {
      instance.logoutRedirect({
        postLogoutRedirectUri: 'https://www.hr.boonsirifishery.com',
      });
    }

    setOpen(null);
    removeCookies(['session']);
    removeCookies(['imageProfile']);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={
            name?.employeeCode?`https://api-hr.boonsiri.co.th/public/images/profile/${name?.employeeCode}_1.jpg`:data?.getCandidate?.profileImage?
            `https://api-hr.boonsiri.co.th${data?.getCandidate?.profileImage}`:
            'https://mui.com/static/images/avatar/16.jpg'
          }
          alt={
            name?.nameTh === 'null null'
              ? 'ไม่ได้ระบุชื่อ'
              : name?.nameTh || decodedToken?.nameTh === 'null null'
              ? data?.getCandidate?.firstName
                ? data?.getCandidate?.firstName
                : 'ไม่ได้ระบุชื่อ'
              : decodedToken?.nameTh || 'ไม่ได้ระบุชื่อ'
          }
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
            overflow: 'hidden',
          }}
          imgProps={{
            style: {
              objectFit: 'cover',
              objectPosition: 'top', // ทำให้แสดงส่วนหัวไว้ด้านบน
            },
          }}
        />
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 'auto',
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {name?.nameTh === 'null null'
              ? 'ไม่ได้ระบุชื่อ'
              : name?.nameTh || decodedToken?.nameTh === 'null null'
              ? data?.getCandidate?.firstName
                ? `${data?.getCandidate?.firstName} ${data?.getCandidate?.lastName}`
                : name?.nameTh
                ? name?.nameTh
                : 'ไม่ได้ระบุชื่อ'
              : decodedToken?.nameTh || 'ไม่ได้ระบุชื่อ'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {name?.email || decodedToken?.email || 'ไม่ได้ระบุชื่อ'}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {MENU_OPTIONS.filter(
          (option) => !(decodeData?.candidateId && (option.label === 'นามบัตร'||option.label === 'บัตรพนักงาน'))
        ).map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              if (option.label === 'โปรไฟล์') {
                const path = decodeData.candidateId
                  ? '/profile'
                  : `/employee/${name?.employeeCode}`;
                navigate(path);
                handleClose();
              } else if (option.label === 'นามบัตร') {
                navigate('cardBusiness');
                handleClose();
              } else if (option.label === 'บัตรพนักงาน') {
                navigate('employeeIdCard');
                handleClose();
              } else if (option.label === 'หน้าหลัก') {
                navigate('/');
                handleClose();
              } else if (option.label === 'ตั้งค่าคุกกี้และ PDPA') {
                setData((prev) => ({ ...prev, cookieSettingsOpen: true }));
                handleClose();
              } else {
                handleClose();
              }
            }}
          >
            {option.label}
          </MenuItem>
        ))}

        <Divider sx={{ borderStyle: 'dashed', m: 0 }} />

        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={handleLogout}
          sx={{ typography: 'body2', color: 'error.main', py: 1.5 }}
        >
          ออกจากระบบ
        </MenuItem>
      </Popover>
    </>
  );
}
